import { useEffect as i } from "react";
function t(s, o, u) {
  const e = u || window;
  i(() => {
    if (!e) {
      console.warn("useOnKeyPress: target element is not found");
      return;
    }
    const r = (n) => {
      n.key === s && o(n);
    };
    return e == null || e.addEventListener("keyup", r), function() {
      e == null || e.removeEventListener("keyup", r);
    };
  }, [s, o, e]);
}
export {
  t as useOnKeyPress
};
